import { render, staticRenderFns } from "./CreateDay.vue?vue&type=template&id=5b552e0c&scoped=true&"
import script from "./CreateDay.vue?vue&type=script&lang=js&"
export * from "./CreateDay.vue?vue&type=script&lang=js&"
import style0 from "./CreateDay.vue?vue&type=style&index=0&id=5b552e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b552e0c",
  null
  
)

export default component.exports